import { ThunkAction } from 'redux-thunk';
import * as Bixby from './../../core';
import { AppState } from './..';
import { TRANSACTION_COMPS_LOADING, TRANSACTION_COMPS_SUCCESS, TRANSACTION_COMPS_FAILURE } from './types';
import { CompanyService } from '$/services';

export const loadTransactionCompsAction = () => {
  return {
    type: TRANSACTION_COMPS_LOADING,
  };
};

export const transactionCompsSuccessAction = (payload: Bixby.Models.CompanyTransactionComp[]) => {
  return {
    type: TRANSACTION_COMPS_SUCCESS,
    payload,
  };
};

export const transactionCompsFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: TRANSACTION_COMPS_FAILURE,
    payload: error,
    error: true,
  };
};

// thunk actions

export const getTransactionComps =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadTransactionCompsAction());
    try {
      const transactionComps = await CompanyService.getTransactionComps();
      dispatch(transactionCompsSuccessAction(transactionComps));
    } catch (error: any) {
      dispatch(transactionCompsFailureAction(error));
    }
  };
